import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText, Popper, Grow, Paper, ClickAwayListener, MenuList } from "@mui/material";
import React, { useState } from "react";
import { colours } from "../../../StyleConstants";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_FULL_WIDTH } from "../Sidebar";

type DropdownMenuButtonProps = {
    id: string;
    icon: any,
    label: string,
    menu?: MenuItemType[],
    selected: boolean,
}

type MenuItemType = {
    label: string,
    path: string,
}
const DropdownSidebarItem = (props: DropdownMenuButtonProps) => {
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);
    const open = Boolean(anchorRef.current);
    const navigate = useNavigate();

    const handleClose = (event: Event | React.SyntheticEvent) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        setIsProfileMenuOpen(false);
    };
    const handleToggle = () => {
        setIsProfileMenuOpen((prevOpen) => !prevOpen);
    };
    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === "Tab") {
            event.preventDefault();
            setIsProfileMenuOpen(false);
        } else if (event.key === "Escape") {
            setIsProfileMenuOpen(false);
        }
    }

    return (
        <Box ref={anchorRef} component="li">
            <ListItem
                disablePadding
                sx={{ display: 'block' }}
            >
                <ListItemButton
                    id={`dropdown-sidebar-item-${props.label}`}
                    aria-controls={open ? `${props.label} menu` : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleToggle}
                    sx={props.selected ? {
                        height: "40px",
                        backgroundColor: "#F9FAFC",
                        width: props.selected ? SIDEBAR_FULL_WIDTH + 8 : 208,
                        pr: 0,
                        borderRadius: "8px 0px 0px 8px",
                        "&:hover": {
                            backgroundColor: "#F9FAFC",
                        },
                    }
                        : {
                            height: "40px",
                            width: "208px",
                        }}
                >
                    <ListItemIcon>
                        <props.icon
                            sx={{
                                color: props.selected ? colours.orange.orange : 'white',
                                width: "1rem",
                                aspectRatio: 1,
                            }}
                        />
                    </ListItemIcon>
                    <ListItemText
                        disableTypography
                        primary={props.label}
                        // sx={{ marginLeft: "-1rem" }}
                        sx={{
                            color: props.selected ? colours.orange.orange : 'white',
                            marginLeft: "-1rem",
                            fontWeight: props.selected ? "600" : "400",
                        }}
                    />
                </ListItemButton>
                <Popper
                    open={isProfileMenuOpen}
                    anchorEl={anchorRef.current}
                    placement="right-start"
                    transition
                >
                    {({ TransitionProps }) => (
                        <Grow {...TransitionProps}>
                            <Paper>
                                <ClickAwayListener
                                    onClickAway={handleClose}
                                >
                                    <MenuList
                                        autoFocusItem={isProfileMenuOpen}
                                        id="composition-menu"
                                        aria-labelledby="composition-button"
                                        onKeyDown={handleListKeyDown}
                                        sx={{ color: colours.midnightBlue.blue160 }}
                                    >
                                        {props.menu?.map((item: MenuItemType) => (
                                            <ListItemButton
                                                key={item.path}
                                                onClick={() => navigate(item.path)}
                                                id={`dropdown-sidebar-item-${item.path}`}
                                            >
                                                <ListItemText>
                                                    {item.label}
                                                </ListItemText>
                                            </ListItemButton>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </ListItem>
        </Box>

    )
}

export default DropdownSidebarItem;